import React, { Component } from "react";
import { Input, FormGroup, Label, FormFeedback } from "reactstrap";
import { IMaskMixin } from "react-imask";
import CurrencyInput from "../components/CurrencyInput";

const MaskedInput = IMaskMixin(({ inputRef, error, row, ...props }) => (
  <Input xs={row} {...props} invalid={error} step="any" innerRef={inputRef} />
));

class DefaultInput extends Component {
  input = null;

  renderInput() {
    const { name, error, row, mask, onChange, ...rest } = this.props;

    //TODO: remove all rest parameters
    const restProp = { ...rest };
    if (!restProp.autoComplete) {
      delete restProp.autoComplete;
    }

    if (mask) {
      console.log("input", "mask", name);
      return (
        <MaskedInput
          inputRef={(el) => (this.input = el)}
          row={row && "auto"}
          unmask={true}
          {...restProp}
          name={name}
          id={name}
          error={error ? true : false}
          mask={mask}
          onAccept={(value) => onChange(this.input, value)}
        ></MaskedInput>
      );
    } else if (this.props.currency) {
      console.log("input", "currency", name);
      return (
        //TODO: remove all rest parameters
        <CurrencyInput
          name={name}
          id={name}
          onChangeEvent={(e) => {
            onChange({ currentTarget: e.target });
          }}
          {...rest}
        />
      );
    }
    console.log("input", "normal", name);

    return (
      <Input
        xs={row && "auto"}
        {...restProp}
        name={name}
        id={name}
        invalid={error ? true : false}
        onChange={onChange}
        step="any"
      />
    );
  }

  render() {
    const {
      name,
      label,
      error,
      row,
      bold,
      required,
    } = this.props;

    return (
      <FormGroup row={row} className={required ? "required" : ""}>
        {label && (
          <Label
            xs={row && "auto"}
            for={name}
            className={bold ? "font-weight-bold" : ""}          >
            <span>{label}</span>
            {/* {secondaryLabel !== "" && (
              <span className="font-weight-light">
                {" "}
                {"-"}
              </span>
            )} */}
          </Label>
        )}
        {this.renderInput()}

        <FormFeedback>{error}</FormFeedback>
      </FormGroup>
    );
  }
}

export default DefaultInput;
